/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MsInputs */

const en_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const es_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const fr_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const de_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const ja_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const zh_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const ar_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملي ثانية (`)
};

const id_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const it_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const ru_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мс (`)
};

const pt_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

const ko_ms = /** @type {(inputs: MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ms (`)
};

/**
* | output |
* | --- |
* | "ms (" |
*
* @param {MsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ms = /** @type {((inputs?: MsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ms(inputs)
	if (locale === "es") return es_ms(inputs)
	if (locale === "fr") return fr_ms(inputs)
	if (locale === "de") return de_ms(inputs)
	if (locale === "ja") return ja_ms(inputs)
	if (locale === "zh") return zh_ms(inputs)
	if (locale === "ar") return ar_ms(inputs)
	if (locale === "id") return id_ms(inputs)
	if (locale === "it") return it_ms(inputs)
	if (locale === "ru") return ru_ms(inputs)
	if (locale === "pt") return pt_ms(inputs)
	return ko_ms(inputs)
});